import type { GameState, GameStateCompressed } from '@genially/p2p-lib';

import { GameCompressor } from './GameCompressor';

export class FakeGameCompressor extends GameCompressor {
  compress(game: GameState): GameStateCompressed {
    return JSON.stringify(game);
  }

  decompress(compressedGame: GameStateCompressed): GameState {
    return JSON.parse(compressedGame);
  }
}
